import axios from "axios";
import {ordersServicesPath} from "../../../Constants";
import ObjectUtil from "../../../utils/common/ObjectUtil";

const materialReserveRestUrl = ordersServicesPath + '/organizations/material-reserve'

export default class MaterialReserveService {

    static async getAllNotArchivePieceMaterial() {
        return axios.get(materialReserveRestUrl + '/not-archive-piece-material');
    }

    static async getAllByIssuingEdgeId(issuingEdgeId) {
        return axios.get(materialReserveRestUrl + '/get-all-by-issuing-edge-id' + '?issuingEdgeId=' + issuingEdgeId);
    }

    static async getAllNotArchiveSlabMaterial() {
        return axios.get(materialReserveRestUrl + '/not-archive-slab-material');
    }

    static async getAllNotArchiveLinearMaterial() {
        return axios.get(materialReserveRestUrl + '/not-archive-liner-material');
    }

    static async getAllByWorkingCuttingMapId(workingCuttingMapId) {
        return axios.get(materialReserveRestUrl + '/get-all-by-working-cutting-map-id' + '?workingCuttingMapId=' + workingCuttingMapId);
    }

    static async getAllByMaterialEstimateUnitId(type, materialEstimateUnitId) {
        if (type === 'calculation') {
            return MaterialReserveService.getAllCalculationByMaterialEstimateUnitId(materialEstimateUnitId);
        } else {
            return MaterialReserveService.getAllActualByMaterialEstimateUnitId(materialEstimateUnitId);
        }
    }

    static async getAllByMaterialWarehouseId(materialWarehouseId) {
        return axios.get(materialReserveRestUrl + '/get-all-by-material-warehouse-id' + '?materialWarehouseId=' + materialWarehouseId);
    }

    static async getAllByMaterialPriceUnitId(materialPriceUnitId) {
        return axios.get(materialReserveRestUrl + '/get-all-by-material-price-unit-id' + '?materialPriceUnitId=' + materialPriceUnitId);
    }

    static
    async getAllActualByMaterialEstimateUnitId(materialEstimateUnitId) {
        return axios.get(materialReserveRestUrl + '/get-all-by-material-estimate-unit-id' + '?materialEstimateUnitId=' + materialEstimateUnitId);
    }

    static
    async getAllCalculationByMaterialEstimateUnitId(materialEstimateUnitId) {
        return axios.get(materialReserveRestUrl + '/get-all-calculation-by-material-estimate-unit-id' + '?materialEstimateUnitId=' + materialEstimateUnitId);
    }

    static async issue(id) {
        return await axios.post(materialReserveRestUrl + '/' + id + '/issue', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async setIssued(id) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/set-issued', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async return(id) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/return', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }


    static async setPackaging(id, status) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/set-packaging' + '?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setState(id, state) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/set-state?state=' + state, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async returnPurchase(id) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/return-purchase', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async returnPurchases(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(materialReserveRestUrl + '/return-purchase-by-ids', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteArrival(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(materialReserveRestUrl + '/delete-arrival', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setSupplier(id, supplierId, typeMaterialReserve) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/set-supplier' + '?supplierId=' + supplierId
            + '&typeMaterialReserve=' + typeMaterialReserve, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setSupplierByIds(ids, supplierId, typeMaterialReserve) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(materialReserveRestUrl + '/set-supplier-by-ids?supplierId=' + supplierId + '&typeMaterialReserve=' + typeMaterialReserve, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setPurchase(id) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/set-purchase', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setPurchaseByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(materialReserveRestUrl + '/set-purchase', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(materialReserveRestUrl + '/' + id);
    }

    static async divide(id, quantity) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/divide?quantity=' + quantity, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(materialReserveRestUrl + '/delete-by-ids', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async editNote(id, note) {
        return await axios.patch(materialReserveRestUrl + '/' + id + '/set-note', JSON.stringify({note: note}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(materialEstimateUnitId, materialWarehouseId, supplierMaterialId,
                      quantity, costMaterial, priceMaterial, costEstimate, priceEstimate, width) {

        const params = new URLSearchParams({
            costMaterial,
            priceMaterial,
            costEstimate,
            priceEstimate,
            materialEstimateUnitId,
            quantity
        });

        if (supplierMaterialId !== null) {
            params.append('supplierMaterialId', supplierMaterialId);
        }

        if (materialWarehouseId !== null) {
            params.append('materialWarehouseId', materialWarehouseId);
        }

        if (width !== null) {
            params.append('width', width);
        }

        return await axios.post(materialReserveRestUrl + '?' + params.toString(), [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async fillFromWarehouse(id, materialWarehouseId) {
        return await axios.post(materialReserveRestUrl + '/' + id + '/fill-from-warehouse?materialWarehouseId=' + materialWarehouseId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async fillFromWarehouseByIds(ids, materialWarehouseId) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(materialReserveRestUrl + '/fill-from-warehouse-by-ids?materialWarehouseId=' + materialWarehouseId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async sendPurchaseByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(materialReserveRestUrl + '/purchase-by-working-cutting-map-ids', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}